const communes = [
  "Katuba",
  "Lubumbashi",
  "Kampemba",
  "Ruashi",
  "Kenya",
  "Kamalondo",
  "Annexe",
  "Bandalungwa",
  "Barumbu",
  "Bumbu",
  "Gombe",
  "Kalamu",
  "Kasa-Vubu",
  "Kimbanseke",
  "Kinshasa",
  "Kintambo",
  "Kisenso",
  "Lemba",
  "Limete",
  "Lingwala",
  "Makala",
  "Maluku",
  "Masina",
  "Matete",
  "Mont-Ngafula",
  "Ndjili",
  "Ngaba",
  "Ngaliema",
  "Ngiri-Ngiri",
  "Nsele",
  "Selembao",
  "Ville-province",
];
export {
  communes
};



// WEBPACK FOOTER //
// ./src/api/communes.js